module.exports = __webpack_public_path__ + "static/media/1POLICY31.99fb0b0f.jpg";